module.exports = __webpack_public_path__ + "img/f9a2cafd19603422f7e454124b96691.017f6aef.jpg";